<template>
  <div class="top-menu-mobile">
    <div class="top-menu-center">
      <div class="right-menu">
        <img src="../../assets/img2/mobile/common/m-menu.png" alt="" @click="onClickShowMenu">
      </div>
      <a href="/">
        <img class="main-logo" src="../../assets/img2/pc/fzg-logo.png"/>
      </a>

      <div v-if="isShowMenu" class="fzg-menu-mobile">
        <div class="close-icon" @click="isShowMenu = false">
          <img src="../../assets/img2/mobile/common/close.png" alt="">
        </div>

        <a class="menu-item" :class="{'menu-item-active': isMenuActive('/')}" href="/">首页</a>
        <a class="menu-item" :class="{'menu-item-active': isMenuActive('/about')}" href="/about">关于我们</a>
        <a class="menu-item" :class="{'menu-item-active': isMenuActive('/service')}" href="/service">小饭桌创服</a>
        <a class="menu-item" :class="{'menu-item-active': isMenuActive('/investment')}" href="/investment">小饭桌创投</a>
        <a class="menu-item" :class="{'menu-item-active': isMenuActive('/fa')}" href="/fa">凡卓资本</a>
        <a class="menu-item" :class="{'menu-item-active': isMenuActive('/news')}" href="/news">动态新闻</a>
        <a class="menu-item" :class="{'menu-item-active': isMenuActive('/join')}" href="/join">加入我们</a>

        <a v-if="false" class="menu-item " href="https://www.xfz.cn/" target="blank">小饭桌媒体门户</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isShowMenu: false,
    }
  },
  methods: {
    isMenuActive(path) {
      return this.$route.path == path
    },
    onClickShowMenu() {
      this.isShowMenu = true
    }
  }
}

</script>

<style lang="scss" scoped>
  .top-menu-mobile {
    // background: #ccc;
    // border: 1px solid red;
    // height: 70px;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    .top-menu-center {
      // border: 1px solid green;
      width: 100%;
      margin: 10px auto 0;
      .main-logo {
        // border: 1px solid red;
        width: 110px;
        margin-right: 10px;
        margin-left: 30px;
        margin-top: 10px;
      }
      .right-menu {
        float: right;
        // border: 1px solid red;
        vertical-align: top;
        width: 30px;
        height: 30px;
        margin-top: 10px;
        margin-right: 20px;
        img {
          width: 100%;
        }
      }
      .fzg-menu-mobile {
        // border: 1px solid red;
        background-color: #000000;
	      opacity: 0.84;
        width: 100%;
        position: fixed;
        top: 0;
        bottom: 0;
        z-index: 99;
        padding-top: 80px;
        .close-icon {
          position: fixed;
          top: 20px;
          right: 20px;
          bottom: 0;
          img {
            width: 30px;
          }
        }

        .menu-item {
          margin: 0 20px;
          border-bottom: 1px solid #ffffff33;
          color: white;
          display: block;
          font-size: 16px;
          padding: 20px 5px;
          text-align: center;
          &:hover, &.active {
            color: #ca222a;
          }
        }
        .menu-item-active {
          color: #ca222a;
        }
        .menu-media {
          border: 1px solid #ce262f;
          color: #ca222a;
          width: 140px;
          padding: 4px 6px;
          border-radius: 15px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// FzgMenuMobile.vue?6c7830e3